import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "2020"
    }}>{`2020`}</h1>
    <h2 {...{
      "id": "december-18-2020"
    }}>{`December 18, 2020`}</h2>
    <h3 {...{
      "id": "all-ios-extensions"
    }}>{`All iOS extensions`}</h3>
    <p>{`The AEP SDKs are now distributed using XCFrameworks in order to support hardware with the new Apple M1 architecture while maintaining support for existing Intel architecture.`}</p>
    <p><strong parentName="p">{`IMPORTANT:`}</strong>{` Upgrading to XCFrameworks distribution requires Xcode 12.0 or newer`}</p>
    <p><strong parentName="p">{`IMPORTANT:`}</strong>{` If using Cocoapods, upgrading to the XCFrameworks distribution requires Cocoapods 1.10.0 or newer`}</p>
    <p>{`Below is a list of the new versions for each extension:`}</p>
    <ul>
      <li parentName="ul">{`iOS Core 2.9.0`}
        <ul parentName="li">
          <li parentName="ul">{`iOS Identity 2.5.0`}</li>
          <li parentName="ul">{`iOS Lifecycle 2.2.0`}</li>
          <li parentName="ul">{`iOS Signal 2.2.0`}</li>
        </ul>
      </li>
      <li parentName="ul">{`iOS Analytics 2.5.0`}</li>
      <li parentName="ul">{`iOS Assurance 1.1.0`}</li>
      <li parentName="ul">{`iOS Audience 2.2.0`}</li>
      <li parentName="ul">{`iOS Campaign 1.1.0`}</li>
      <li parentName="ul">{`iOS Campaign Classic 2.1.0`}</li>
      <li parentName="ul">{`iOS Media 2.3.0`}</li>
      <li parentName="ul">{`iOS Mobile Services 1.1.0`}</li>
      <li parentName="ul">{`iOS Places 1.4.0`}</li>
      <li parentName="ul">{`iOS Target 2.2.0`}</li>
      <li parentName="ul">{`iOS User Profile 2.2.0`}</li>
    </ul>
    <h2 {...{
      "id": "december-3-2020"
    }}>{`December 3, 2020`}</h2>
    <h3 {...{
      "id": "android-identity-122"
    }}>{`Android Identity 1.2.2`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Fix issue where push identifier had incorrect value in Identity shared state when `}<inlineCode parentName="p">{`setPushIdentifer`}</inlineCode>{` was not called on each launch.`}</p>
        <p parentName="li">{`Released with sdk-core version 1.5.8`}</p>
      </li>
    </ul>
    <h2 {...{
      "id": "december-2-2020"
    }}>{`December 2, 2020`}</h2>
    <h3 {...{
      "id": "ios-core-282"
    }}>{`iOS Core 2.8.2`}</h3>
    <ul>
      <li parentName="ul">{`Update version for bundled ACPIdentity 2.4.1 release.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-identity-241"
    }}>{`iOS Identity 2.4.1`}</h3>
    <ul>
      <li parentName="ul">{`Fix issue where push identifier had incorrect value in Identity shared state when `}<inlineCode parentName="li">{`setPushIdentifer`}</inlineCode>{` was not called on each launch.`}</li>
    </ul>
    <h2 {...{
      "id": "november-24-2020"
    }}>{`November 24, 2020`}</h2>
    <h3 {...{
      "id": "android-assurance-101"
    }}>{`Android Assurance 1.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug that triggered ANR (Application not responsive) error while initializing webview.`}</li>
    </ul>
    <h2 {...{
      "id": "november-23-2020"
    }}>{`November 23, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "react-native-assurance-100"
    }}>{`React Native Assurance 1.0.0`}</h3>
    <ul>
      <li parentName="ul">{`AEP Assurance extension released for React Native. See: `}<a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@adobe/react-native-aepassurance"
        }}>{`Assurance React Native`}</a></li>
    </ul>
    <h3 {...{
      "id": "flutter-assurance-101"
    }}>{`Flutter Assurance 1.0.1`}</h3>
    <ul>
      <li parentName="ul">{`AEP Assurance extension released for Flutter. See: `}<a parentName="li" {...{
          "href": "https://pub.dev/packages/flutter_assurance"
        }}>{`Assurance Flutter`}</a></li>
    </ul>
    <h3 {...{
      "id": "xamarin-assurance-001"
    }}>{`Xamarin Assurance 0.0.1`}</h3>
    <ul>
      <li parentName="ul">{`AEP Assurance extension released for Xamarin iOS. See : `}<a parentName="li" {...{
          "href": "https://www.nuget.org/packages/Adobe.AEPAssurance.iOS/"
        }}>{`Assurance Xamarin iOS`}</a></li>
      <li parentName="ul">{`AEP Assurance extension released for Xamarin Android. See : `}<a parentName="li" {...{
          "href": "https://www.nuget.org/packages/Adobe.AEPAssurance.Android/"
        }}>{`Assurance Xamarin Android`}</a></li>
    </ul>
    <h3 {...{
      "id": "cordova-assurance-001"
    }}>{`Cordova Assurance 0.0.1`}</h3>
    <ul>
      <li parentName="ul">{`AEP Assurance extension released for Cordova. See : `}<a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@adobe/cordova-aepassurance"
        }}>{`Assurance Cordova`}</a></li>
    </ul>
    <h3 {...{
      "id": "unity-assurance-001"
    }}>{`Unity Assurance 0.0.1`}</h3>
    <ul>
      <li parentName="ul">{`AEP Assurance extension released for Unity. See: `}<a parentName="li" {...{
          "href": "https://github.com/adobe/unity-aepassurance"
        }}>{`Assurance Unity`}</a></li>
    </ul>
    <h2 {...{
      "id": "november-18-2020"
    }}>{`November 18, 2020`}</h2>
    <h3 {...{
      "id": "ios-core-281"
    }}>{`iOS Core 2.8.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a memory alignment issue that caused crashes in iOS 10.x.`}</li>
    </ul>
    <h2 {...{
      "id": "november-9-2020"
    }}>{`November 9, 2020`}</h2>
    <h3 {...{
      "id": "android-audience-110"
    }}>{`Android Audience 1.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Added support for AdobeCallbackWithError for APIs getVisitorProfile, signalWithData.`}</li>
      <li parentName="ul">{`Added changes to publish Audience shared state on EventHub boot.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-audience-210"
    }}>{`iOS Audience 2.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Added new APIs getVisitorProfileWithCompletionHandler, signalWithData:WithCompletionHandler. These APIs take completion handler as an argument which is invoked with the desirable response or an NSError if an unexpected error occurs or the request times out.`}</li>
      <li parentName="ul">{`Added changes to publish Audience shared state on EventHub boot.`}</li>
      <li parentName="ul">{`Fixed an issue to handle Analytics response only if AAMForwarding is enabled.`}</li>
    </ul>
    <h2 {...{
      "id": "november-4-2020"
    }}>{`November 4, 2020`}</h2>
    <h3 {...{
      "id": "ios-core-280"
    }}>{`iOS Core 2.8.0`}</h3>
    <ul>
      <li parentName="ul">{`Update version for bundled ACPIdentity 2.4.0 release.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-identity-240"
    }}>{`iOS Identity 2.4.0`}</h3>
    <ul>
      <li parentName="ul">{`Added a `}<inlineCode parentName="li">{`device_consent`}</inlineCode>{` status parameter when `}<inlineCode parentName="li">{`setAdvertisingIdentifier`}</inlineCode>{` is called after ad tracking is enabled/disabled.`}</li>
      <li parentName="ul">{`The default Identity Server URL of `}<inlineCode parentName="li">{`dpm.demdex.com`}</inlineCode>{` is used if the SDK configuration parameter `}<inlineCode parentName="li">{`experienceCloud.server`}</inlineCode>{` is either missing or an empty string.`}</li>
    </ul>
    <h2 {...{
      "id": "october-27-2020"
    }}>{`October 27, 2020`}</h2>
    <h3 {...{
      "id": "ios-griffon-121"
    }}>{`iOS Griffon 1.2.1`}</h3>
    <ul>
      <li parentName="ul">{`Minor bugs fixed.`}</li>
    </ul>
    <h2 {...{
      "id": "october-21-2020"
    }}>{`October 21, 2020`}</h2>
    <h3 {...{
      "id": "ios-core-276"
    }}>{`iOS Core 2.7.6`}</h3>
    <ul>
      <li parentName="ul">{`Fixed several crashes that were happening during app shutdown.`}</li>
    </ul>
    <h2 {...{
      "id": "october-7-2020"
    }}>{`October 7, 2020`}</h2>
    <h3 {...{
      "id": "android-media-210"
    }}>{`Android Media 2.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Changed the `}<strong parentName="li">{`default`}</strong>{` Ad tracking granularity to `}<strong parentName="li">{`10 seconds`}</strong>{`. Added configuration key to enable 1 sec ad tracking.`}</li>
      <li parentName="ul"><strong parentName="li">{`Restart`}</strong>{` tracking session every `}<strong parentName="li">{`24 hours`}</strong>{` for long running sessions.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-media-220"
    }}>{`iOS Media 2.2.0`}</h3>
    <ul>
      <li parentName="ul">{`Changed the `}<strong parentName="li">{`default`}</strong>{` Ad tracking granularity to `}<strong parentName="li">{`10 seconds`}</strong>{`. Added configuration key to enable 1 sec ad tracking.`}</li>
      <li parentName="ul"><strong parentName="li">{`Restart`}</strong>{` tracking session every `}<strong parentName="li">{`24 hours`}</strong>{` for long running sessions.`}</li>
    </ul>
    <h2 {...{
      "id": "october-6-2020"
    }}>{`October 6, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-analytics-240"
    }}>{`iOS Analytics 2.4.0`}</h3>
    <ul>
      <li parentName="ul">{`Added new APIs getQueueSizeWithCompletionHandler, getTrackingIdentifierWithCompletionHandler and getVisitorIdentifierWithCompletionHandler. These APIs take completion handler as an argument which is invoked with the desirable response or an NSError if an unexpected error occurs or the request times out.`}</li>
      <li parentName="ul">{`Added an enhancement to append previous app id and previous os version to backdated session info hits.`}</li>
      <li parentName="ul">{`Changes to read from Assurance shared state.`}</li>
    </ul>
    <h2 {...{
      "id": "october-5-2020"
    }}>{`October 5, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-assurance-100"
    }}>{`Android Assurance 1.0.0`}</h3>
    <ul>
      <li parentName="ul">{`General availability and release of Adobe Experience Platform Assurance that enables capabilities of Project Griffon.`}</li>
    </ul>
    <h3 {...{
      "id": "android-analytics-126"
    }}>{`Android Analytics 1.2.6`}</h3>
    <ul>
      <li parentName="ul">{`Added error callbacks for following APIs getQueueSize, getTrackingIdentifier and getVisitorIdentifier. Instance of AdobeCallbackWithError can be passed to these API's as an argument to receive error callbacks.`}</li>
      <li parentName="ul">{`Added an enhancement to append previous app id and previous os version to backdated session info hits.`}</li>
      <li parentName="ul">{`Changes to read from Assurance shared state.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-assurance-100"
    }}>{`iOS Assurance 1.0.0`}</h3>
    <ul>
      <li parentName="ul">{`General availability and release of Adobe Experience Platform Assurance that enables capabilities of Project Griffon.`}</li>
    </ul>
    <h2 {...{
      "id": "september-29-2020"
    }}>{`September 29, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-campaign-107"
    }}>{`Android Campaign 1.0.7`}</h3>
    <ul>
      <li parentName="ul">{`Added an enhancement to reduce the number of registration requests sent to Campaign. There is now a default 7 day registration delay which starts after the most recent registration request sent to Campaign is successful.`}</li>
      <li parentName="ul">{`Added configuration settings to change the default registration delay or to pause registration requests.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-campaign-106"
    }}>{`iOS Campaign 1.0.6`}</h3>
    <ul>
      <li parentName="ul">{`Added an enhancement to reduce the number of registration requests sent to Campaign. There is now a default 7 day registration delay which starts after the most recent registration request sent to Campaign is successful.`}</li>
      <li parentName="ul">{`Added configuration settings to change the default registration delay or to pause registration requests.`}</li>
    </ul>
    <h2 {...{
      "id": "september-23-2020"
    }}>{`September 23, 2020`}</h2>
    <h3 {...{
      "id": "android-project-griffon-121"
    }}>{`Android Project Griffon 1.2.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed dropped events and connection termination issues caused by exceeding maximum data capacity of a websocket connection.`}</li>
    </ul>
    <h2 {...{
      "id": "september-22-2020"
    }}>{`September 22, 2020`}</h2>
    <h3 {...{
      "id": "ios-core-275"
    }}>{`iOS Core 2.7.5`}</h3>
    <ul>
      <li parentName="ul">{`Fixes an issue where the EventHub could be blocked by synchronous network calls returning recoverable errors.`}</li>
    </ul>
    <h2 {...{
      "id": "september-16-2020"
    }}>{`September 16, 2020`}</h2>
    <h3 {...{
      "id": "ios-14-compatibility"
    }}>{`iOS 14 Compatibility`}</h3>
    <ul>
      <li parentName="ul">{`Latest extension versions of Adobe Experience Platform Mobile SDK are now certified for iOS 14. Please see `}<a parentName="li" {...{
          "href": "../sdk-versions.md"
        }}>{`SDK Versions`}</a>{` for more information on the latest version numbers.`}</li>
    </ul>
    <h2 {...{
      "id": "september-15-2020"
    }}>{`September 15, 2020`}</h2>
    <h3 {...{
      "id": "android-project-griffon-120"
    }}>{`Android Project Griffon 1.2.0`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue caused by when extension unregistration and Shared State read events happen concurrently.`}</li>
      <li parentName="ul">{`New modified event structure is used to communicate with backend servers.`}</li>
      <li parentName="ul">{`New client details such as OSName, OS version, Model name, battery status, screen size, current location permission, low power mode and application configuration are now sent as a part of client event.`}</li>
      <li parentName="ul">{`The following public APIs are removed: attemptReconnect, sendEvent, sendBlob, loglocalUILevel and registerListenerForVendor.`}</li>
      <li parentName="ul">{`Improvements to client connection error screen to provide relevant error messages and descriptions.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-project-griffon-120"
    }}>{`iOS Project Griffon 1.2.0`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue caused by when extension unregistration and Shared State read events happen concurrently.`}</li>
      <li parentName="ul">{`New modified event structure is used to communicate with backend servers.`}</li>
      <li parentName="ul">{`New client details such as OSName, OS version, Model name, battery status, screen size, current location permission, low power mode and application configuration are now sent as a part of client event.`}</li>
      <li parentName="ul">{`The following public APIs are removed: attemptReconnect, sendEvent, sendBlob, loglocalUILevel, and registerListenerForVendor.`}</li>
      <li parentName="ul">{`Improvements to client connection error screen to provide relevant error messages and descriptions.`}</li>
    </ul>
    <h2 {...{
      "id": "september-11-2020"
    }}>{`September 11, 2020`}</h2>
    <h3 {...{
      "id": "android-11-compatibility"
    }}>{`Android 11 Compatibility`}</h3>
    <ul>
      <li parentName="ul">{`Latest extension versions of Adobe Experience Platform Mobile SDK are now certified for Android 11. Please see `}<a parentName="li" {...{
          "href": "../sdk-versions.md"
        }}>{`SDK Versions`}</a>{` for more information on the latest version numbers.`}</li>
    </ul>
    <h2 {...{
      "id": "september-10-2020"
    }}>{`September 10, 2020`}</h2>
    <h3 {...{
      "id": "ios-core-274"
    }}>{`iOS Core 2.7.4`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an intermitted issue where third party extensions may experience crashes after unregistration when using the `}<inlineCode parentName="li">{`ACPExtensionAPI`}</inlineCode>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-lifecycle-212"
    }}>{`iOS Lifecycle 2.1.2`}</h3>
    <ul>
      <li parentName="ul">{`Added previous application Id and OS version info to lifecycle event data.`}</li>
    </ul>
    <h2 {...{
      "id": "september-9-2020"
    }}>{`September 9, 2020`}</h2>
    <h3 {...{
      "id": "android-core-157"
    }}>{`Android Core 1.5.7`}</h3>
    <ul>
      <li parentName="ul">{`Fixed the issue where it may fail to save caches when `}<inlineCode parentName="li">{`Etag`}</inlineCode>{` contains special characters.`}</li>
    </ul>
    <h3 {...{
      "id": "android-identity-121"
    }}>{`Android Identity 1.2.1`}</h3>
    <ul>
      <li parentName="ul">{`Report extension details to Mobile Core for improved logging and Griffon support.`}</li>
      <li parentName="ul">{`Identity shared state now gets updated in current session on server response changes for blob or locationHint.`}</li>
      <li parentName="ul">{`In order to improve the Analytics push tracking reports, the push notification preferences (`}<inlineCode parentName="li">{`a.push.optin`}</inlineCode>{`) are now forwarded to Analytics whenever the value passed to `}<inlineCode parentName="li">{`setPushIdentifier`}</inlineCode>{` is different than the previous time it was called.`}</li>
      <li parentName="ul">{`Improved existing log messages and added additional logging to assist with debugging.`}</li>
    </ul>
    <h3 {...{
      "id": "android-lifecycle-106"
    }}>{`Android Lifecycle 1.0.6`}</h3>
    <ul>
      <li parentName="ul">{`Added previous application Id and OS version info to lifecycle event data.`}</li>
    </ul>
    <h2 {...{
      "id": "september-8-2020"
    }}>{`September 8, 2020`}</h2>
    <h3 {...{
      "id": "android-campaign-106"
    }}>{`Android Campaign 1.0.6`}</h3>
    <ul>
      <li parentName="ul">{`Added support for weak ETags.`}</li>
    </ul>
    <h2 {...{
      "id": "august-31-2020"
    }}>{`August 31, 2020`}</h2>
    <h3 {...{
      "id": "android-target-116"
    }}>{`Android Target 1.1.6`}</h3>
    <ul>
      <li parentName="ul">{`Added support for configuration option `}<inlineCode parentName="li">{`target.server`}</inlineCode>{` which enables a custom host to be used for Target requests. This configuration option is available in the tag extension starting with version 2.4.0.`}</li>
      <li parentName="ul">{`Public APIs now support error handling via passing `}</li>
    </ul>
    <h3 {...{
      "id": "ios-target-217"
    }}>{`iOS Target 2.1.7`}</h3>
    <ul>
      <li parentName="ul">{`Added support for configuration option `}<inlineCode parentName="li">{`target.server`}</inlineCode>{` which enables a custom host to be used for Target requests. This configuration option is available in the tag extension starting with version 2.4.0.`}</li>
    </ul>
    <h2 {...{
      "id": "august-10-2020"
    }}>{`August 10, 2020`}</h2>
    <h3 {...{
      "id": "ios-core-272-released-with-acpcore-version-273-on-cocoapods"
    }}>{`iOS Core 2.7.2 (Released with ACPCore version 2.7.3 on Cocoapods)`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a crash happening on `}<inlineCode parentName="li">{`AdobeMarketingMobile::RulesEngine::ProcessEventForRules()`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Fixed an issue where null values in rules consequences were not respected.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-identity-232"
    }}>{`iOS Identity 2.3.2`}</h3>
    <ul>
      <li parentName="ul">{`Identity shared state now gets updated in current session on server response changes for blob or locationHint.`}</li>
      <li parentName="ul">{`In order to improve the Analytics push tracking reports, the push notification preferences (`}<inlineCode parentName="li">{`a.push.optin`}</inlineCode>{`) are now forwarded to Analytics whenever the value passed to `}<inlineCode parentName="li">{`setPushIdentifier`}</inlineCode>{` is different than the previous time it was called.`}</li>
      <li parentName="ul">{`Improved safety checks for the Identity APIs with completion handler.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-lifecycle-211"
    }}>{`iOS Lifecycle 2.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Session start time is now added to the shared state of Lifecycle extension.`}</li>
    </ul>
    <h2 {...{
      "id": "august-4-2020"
    }}>{`August 4, 2020`}</h2>
    <h3 {...{
      "id": "android-analytics-125"
    }}>{`Android Analytics 1.2.5`}</h3>
    <ul>
      <li parentName="ul">{`Fixed TimeSinceLaunch not getting reported in analytics hits.`}</li>
      <li parentName="ul">{`Fixed a race condition which was causing a null pointer crash.`}</li>
    </ul>
    <h2 {...{
      "id": "august-3-2020"
    }}>{`August 3, 2020`}</h2>
    <h3 {...{
      "id": "android-campaign-105"
    }}>{`Android Campaign 1.0.5`}</h3>
    <ul>
      <li parentName="ul">{`Added ETag support for Campaign rules download requests.`}</li>
    </ul>
    <h2 {...{
      "id": "july-31-2020"
    }}>{`July 31, 2020`}</h2>
    <h3 {...{
      "id": "android-core-156"
    }}>{`Android Core 1.5.6`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue where null values in rules consequences was not respected.`}</li>
      <li parentName="ul">{`Some internal fixes.`}</li>
    </ul>
    <h3 {...{
      "id": "android-lifecycle-105"
    }}>{`Android Lifecycle 1.0.5`}</h3>
    <ul>
      <li parentName="ul">{`Session start time is now added to the shared state of Lifecycle extension.`}</li>
    </ul>
    <h3 {...{
      "id": "android-mobile-services-105"
    }}>{`Android Mobile Services 1.0.5`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue where acquisition data may not be correctly processed.`}</li>
    </ul>
    <h2 {...{
      "id": "july-24-2020"
    }}>{`July 24, 2020`}</h2>
    <h3 {...{
      "id": "ios-media-211"
    }}>{`iOS Media 2.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a performance issue when tracking media.`}</li>
    </ul>
    <h2 {...{
      "id": "july-22-2020"
    }}>{`July 22, 2020`}</h2>
    <h3 {...{
      "id": "xamarin"
    }}>{`Xamarin`}</h3>
    <ul>
      <li parentName="ul">{`User Profile extension for Android `}<a parentName="li" {...{
          "href": "https://www.nuget.org/packages/Adobe.ACPUserProfile.Android/"
        }}>{`released`}</a></li>
      <li parentName="ul">{`User Profile extension for iOS `}<a parentName="li" {...{
          "href": "https://www.nuget.org/packages/Adobe.ACPUserProfile.iOS/"
        }}>{`released`}</a></li>
    </ul>
    <h3 {...{
      "id": "unity"
    }}>{`Unity`}</h3>
    <ul>
      <li parentName="ul">{`User Profile extension for Unity `}<a parentName="li" {...{
          "href": "https://github.com/adobe/unity_acpuserprofile"
        }}>{`released`}</a></li>
    </ul>
    <h2 {...{
      "id": "july-21-2020"
    }}>{`July 21, 2020`}</h2>
    <h3 {...{
      "id": "mobile-core-tag-extension-2115"
    }}>{`Mobile Core tag Extension 2.1.15`}</h3>
    <ul>
      <li parentName="ul">{`Added Modify Data action for tag Rules.`}</li>
      <li parentName="ul">{`Update requires Mobile Core iOS minimum version 2.7.2 and Android minimum version 1.5.5`}</li>
    </ul>
    <h2 {...{
      "id": "july-17-2020"
    }}>{`July 17, 2020`}</h2>
    <h3 {...{
      "id": "android-audience-102"
    }}>{`Android Audience 1.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue where UUID was not returned in getSdkIdentities API response.`}</li>
      <li parentName="ul">{`Fixed an issue where customer visitor IDs were missing from Audience signals.`}</li>
    </ul>
    <h3 {...{
      "id": "android-media-201"
    }}>{`Android Media 2.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a crash when configuring incorrect collection API server.`}</li>
    </ul>
    <h3 {...{
      "id": "xamarin-1"
    }}>{`Xamarin`}</h3>
    <ul>
      <li parentName="ul">{`Places extension released for Xamarin. See current `}<a parentName="li" {...{
          "href": "../sdk-versions.md#xamarin"
        }}>{`Xamarin versions`}</a>{` for more information.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native-audience-112"
    }}>{`React Native Audience 1.1.2`}</h3>
    <ul>
      <li parentName="ul">{`Updated to iOS Audience 2.0.2.`}</li>
      <li parentName="ul">{`Updated to Android Audience 1.0.2.`}</li>
    </ul>
    <h2 {...{
      "id": "july-16-2020"
    }}>{`July 16, 2020`}</h2>
    <h3 {...{
      "id": "android-core-155"
    }}>{`Android Core 1.5.5`}</h3>
    <ul>
      <li parentName="ul">{`Updated the wrapper type strings used by SDK plugins.`}</li>
      <li parentName="ul">{`Added support for the token `}<inlineCode parentName="li">{`~timestampp`}</inlineCode>{` which complies with the Adobe Experience Platform Edge Network.`}</li>
      <li parentName="ul">{`Added support for Modify Data rules.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-core-271-released-with-acpcore-version-272-on-cocoapods"
    }}>{`iOS Core 2.7.1 (Released with ACPCore version 2.7.2 on Cocoapods)`}</h3>
    <ul>
      <li parentName="ul">{`Updated the wrapper type strings used by SDK plugins.`}</li>
      <li parentName="ul">{`Added support for the token `}<inlineCode parentName="li">{`~timestampp`}</inlineCode>{` which complies with the Adobe Experience Platform Edge Network.`}</li>
      <li parentName="ul">{`Another attampt to fix the crash on `}<inlineCode parentName="li">{`std::__1::system_error: mutex lock failed: Invalid argument`}</inlineCode>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "flutter"
    }}>{`Flutter`}</h3>
    <ul>
      <li parentName="ul">{`Places and Places Monitor extension released for Flutter. See current `}<a parentName="li" {...{
          "href": "../sdk-versions.md#flutter"
        }}>{`Flutter versions`}</a>{` for more information.`}</li>
    </ul>
    <h2 {...{
      "id": "july-10-2020"
    }}>{`July 10, 2020`}</h2>
    <h3 {...{
      "id": "ios-audience-202"
    }}>{`iOS Audience 2.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue where UUID was not returned in getSdkIdentities API response.`}</li>
    </ul>
    <h2 {...{
      "id": "july-09-2020"
    }}>{`July 09, 2020`}</h2>
    <h3 {...{
      "id": "flutter-1"
    }}>{`Flutter`}</h3>
    <ul>
      <li parentName="ul">{`Client-side Profile extension released for Flutter see `}<a parentName="li" {...{
          "href": "../profile/index.md#flutter"
        }}>{`Profile`}</a>{` for more information.`}</li>
    </ul>
    <h2 {...{
      "id": "june-26-2020"
    }}>{`June 26, 2020`}</h2>
    <h3 {...{
      "id": "ios-identity-231-released-with-acpcore-version-271-on-cocoapods"
    }}>{`iOS Identity 2.3.1 (Released with ACPCore version 2.7.1 on Cocoapods)`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an intermittent bug where Identity data was not loading at SDK initialization time.`}</li>
    </ul>
    <h3 {...{
      "id": "react-native"
    }}>{`React Native`}</h3>
    <ul>
      <li parentName="ul">{`Places Monitor extension released for React Native see: `}<a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@adobe/react-native-acpplaces-monitor"
        }}>{`Places Monitor React Native`}</a></li>
    </ul>
    <h2 {...{
      "id": "june-24-2020"
    }}>{`June 24, 2020`}</h2>
    <h3 {...{
      "id": "cordova"
    }}>{`Cordova`}</h3>
    <ul>
      <li parentName="ul">{`Places Monitor extension released for Cordova see: `}<a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@adobe/cordova-acpplacesmonitor"
        }}>{`Places Monitor Cordova`}</a></li>
    </ul>
    <h2 {...{
      "id": "june-18-2020"
    }}>{`June 18, 2020`}</h2>
    <h3 {...{
      "id": "ios-project-griffon-113"
    }}>{`iOS Project Griffon 1.1.3`}</h3>
    <ul>
      <li parentName="ul">{`IntegrationId in Griffon's shared state now has format sessionId`}{`|`}{`clientId.`}</li>
    </ul>
    <h2 {...{
      "id": "june-17-2020"
    }}>{`June 17, 2020`}</h2>
    <h3 {...{
      "id": "android-media-201-1"
    }}>{`Android Media 2.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a crash when configuring incorrect collection API server.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-core-270"
    }}>{`iOS Core 2.7.0`}</h3>
    <ul>
      <li parentName="ul">{`Added tvOS compatibility`}</li>
      <li parentName="ul">{`Version 2.7.0 onwards, binaries are built with Xcode 11.0`}</li>
      <li parentName="ul">{`Fixed a crash which happened in AdobeMarketingMobile::ModuleEventListenerBase`}</li>
      <li parentName="ul">{`Added support for Modify Data rules.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-lifecycle-210"
    }}>{`iOS Lifecycle 2.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Added tvOS compatibility`}</li>
      <li parentName="ul">{`Version 2.1.0 onwards, binaries are built with Xcode 11.0`}</li>
    </ul>
    <h3 {...{
      "id": "ios-signal-210"
    }}>{`iOS Signal 2.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Added tvOS compatibility`}</li>
      <li parentName="ul">{`Version 2.1.0 onwards, binaries are built with Xcode 11.0`}</li>
    </ul>
    <h3 {...{
      "id": "ios-identity-230"
    }}>{`iOS Identity 2.3.0`}</h3>
    <ul>
      <li parentName="ul">{`Added tvOS compatibility`}</li>
      <li parentName="ul">{`Version 2.3.0 onwards, binaries are built with Xcode 11.0`}</li>
    </ul>
    <h3 {...{
      "id": "ios-analytics-230"
    }}>{`iOS Analytics 2.3.0`}</h3>
    <ul>
      <li parentName="ul">{`Added tvOS compatibility`}</li>
      <li parentName="ul">{`Version 2.3.0 onwards, binaries are built with Xcode 11.0`}</li>
    </ul>
    <h3 {...{
      "id": "ios-media-210"
    }}>{`iOS Media 2.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Added tvOS compatibility`}</li>
      <li parentName="ul">{`Version 2.1.0 onwards, binaries are built with Xcode 11.0`}</li>
    </ul>
    <h2 {...{
      "id": "june-15-2020"
    }}>{`June 15, 2020`}</h2>
    <h3 {...{
      "id": "react-native-1"
    }}>{`React Native`}</h3>
    <ul>
      <li parentName="ul">{`Support added for Project Griffon`}</li>
      <li parentName="ul">{`Support added for Places`}
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://experienceleague.adobe.com/docs/places/using/places-ext-aep-sdks/places-extension/places-extension.html?lang=en"
            }}>{`See more information in the Places extension section of the Places docs`}</a></li>
        </ul>
      </li>
    </ul>
    <h2 {...{
      "id": "june-12-2020"
    }}>{`June 12, 2020`}</h2>
    <h3 {...{
      "id": "android-project-griffon-117"
    }}>{`Android Project Griffon 1.1.7`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where Griffon unregisters its wildcard listeners during automatic session reconnect.`}</li>
      <li parentName="ul">{`IntegrationId in Griffon's shared state now has format sessionId`}{`|`}{`clientId`}</li>
      <li parentName="ul">{`Griffon pin pad UI support for devices with cutouts from Android version 28 and above.`}</li>
    </ul>
    <h3 {...{
      "id": "cordova-1"
    }}>{`Cordova`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/adobe/cordova-acpplaces"
        }}>{`Support added for Places extension in Cordova`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/adobe/cordova-acpuserprofile"
        }}>{`Support added for Profile extension in Cordova `}</a></li>
    </ul>
    <h2 {...{
      "id": "june-4-2020"
    }}>{`June 4, 2020`}</h2>
    <h3 {...{
      "id": "ios-project-griffon-112"
    }}>{`iOS Project Griffon 1.1.2`}</h3>
    <ul>
      <li parentName="ul">{`Reduced the scope of variable BUFFER`}{`_`}{`SIZE that was exposed globally which may result in naming conflict`}</li>
    </ul>
    <h2 {...{
      "id": "june-2-2020"
    }}>{`June 2, 2020`}</h2>
    <h3 {...{
      "id": "additional-frameworks-supported-by-adobe-experience-platform-mobile-sdk"
    }}>{`Additional frameworks supported by Adobe Experience Platform Mobile SDK`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../sdk-versions.md#cordova"
        }}>{`Apache Cordova `}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../sdk-versions.md#xamarin"
        }}>{`Microsoft Xamarin`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../sdk-versions.md#unity"
        }}>{`Unity`}</a></li>
    </ul>
    <p>{`Each framework supports Mobile Core, Adobe Analytics and Project Griffon. Additionally, these frameworks have been released as open source projects that can be modified to suit your use cases.`}</p>
    <h2 {...{
      "id": "june-1-2020"
    }}>{`June 1, 2020`}</h2>
    <h3 {...{
      "id": "ios-analytics-224"
    }}>{`iOS Analytics 2.2.4`}</h3>
    <ul>
      <li parentName="ul">{`Fixed incorrect timezone offset calculation`}</li>
      <li parentName="ul">{`Fixed a crash which happened in Analytics::TrackLifecycle`}</li>
    </ul>
    <h2 {...{
      "id": "may-28-2020"
    }}>{`May 28, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-core-154"
    }}>{`Android Core 1.5.4`}</h3>
    <ul>
      <li parentName="ul">{`Added the capability for rules engine to reprocess the events that are dispatched before rules are loaded.`}</li>
      <li parentName="ul">{`Fixed a bug where the shared state of event hub was not properly created.`}</li>
      <li parentName="ul">{`Fixed a security issue.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-core-262"
    }}>{`iOS Core 2.6.2`}</h3>
    <ul>
      <li parentName="ul">{`Added the capability for rules engine to reprocess the events that are dispatched before rules are loaded.`}</li>
      <li parentName="ul">{`Fixed the import statement in `}<inlineCode parentName="li">{`ACPNetworkServiceOverrider.h`}</inlineCode>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "may-27-2020"
    }}>{`May 27, 2020`}</h2>
    <h3 {...{
      "id": "ios-project-griffon-111"
    }}>{`iOS Project Griffon 1.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Griffon extension is optimized to unregister itself, when it does not obtain session's deeplink URL within 5 seconds of app launch.`}</li>
      <li parentName="ul">{`Fixed a bug where user is not able to disconnect when griffon attempts to reconnect with expired socket URL.`}</li>
      <li parentName="ul">{`Support for prod, stage, qa and dev environment.`}</li>
      <li parentName="ul">{`Griffon socket connection now authenticates against organization Id.`}</li>
      <li parentName="ul">{`Griffon SDK attempts to seamlessly reconnect to its session on network interruptions.`}</li>
      <li parentName="ul">{`Fixed an issue where "Connect" button does not appear in the pinpad screen on iOS version 10 and below.`}</li>
      <li parentName="ul">{`Fixed a crash that happens when screenshots fails to upload to blob service.`}</li>
      <li parentName="ul">{`Fixed an issue where Griffon floating button disappears during orientation change.`}</li>
    </ul>
    <h2 {...{
      "id": "may-22-2020"
    }}>{`May 22, 2020`}</h2>
    <h3 {...{
      "id": "android-project-griffon-116"
    }}>{`Android Project Griffon 1.1.6`}</h3>
    <ul>
      <li parentName="ul">{`Changes to support Griffon on Xamarin and Unity.`}</li>
      <li parentName="ul">{`Griffon extension is optimized to unregister itself, when it does not obtain session's deeplink URL within 5 seconds of app launch.`}</li>
      <li parentName="ul">{`Fixed a bug where user is not able to disconnect when griffon attempts to reconnect with expired socket URL.`}</li>
      <li parentName="ul">{`Fixed a bug that prevents pinpad screen from closing when Mobile SDK is not configured.`}</li>
      <li parentName="ul">{`Improved logging.`}</li>
    </ul>
    <h2 {...{
      "id": "may-19-2020"
    }}>{`May 19, 2020`}</h2>
    <h3 {...{
      "id": "android-media-200"
    }}>{`Android Media 2.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Uses media collection endpoint for tracking both streaming and downloaded content.`}</li>
      <li parentName="ul">{`Added support for player state tracking`}</li>
    </ul>
    <h3 {...{
      "id": "ios-media-200"
    }}>{`iOS Media 2.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Uses media collection endpoint for tracking both streaming and downloaded content.`}</li>
      <li parentName="ul">{`Added support for player state tracking`}</li>
    </ul>
    <h2 {...{
      "id": "april-24-2020"
    }}>{`April 24, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-campaign-104"
    }}>{`Android Campaign 1.0.4`}</h3>
    <ul>
      <li parentName="ul">{`Changes in how fullscreen in-app messages are displayed inline with WebView security recommendations in Mobile Core 1.5.2 release.`}</li>
      <li parentName="ul">{`Report extension details to Mobile Core for improved logging and Griffon support.`}</li>
      <li parentName="ul">{`Fixed an image caching related bug, where cached images used to get deleted.`}</li>
    </ul>
    <h2 {...{
      "id": "april-22-2020"
    }}>{`April 22, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-project-griffon-115"
    }}>{`Android Project Griffon 1.1.5`}</h3>
    <ul>
      <li parentName="ul">{`Fix bug where pinCode entry activity fails to show when another application's activity is started at the same time.`}</li>
      <li parentName="ul">{`Blob upload services uses production URL with multiple environment support.`}</li>
      <li parentName="ul">{`ClientId is shared as a query parameter to socket URL rather than tagging each Griffon event.`}</li>
      <li parentName="ul">{`Griffon socket connection now authenticates against organization Id.`}</li>
    </ul>
    <h2 {...{
      "id": "april-21-2020"
    }}>{`April 21, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-core-153"
    }}>{`Android Core 1.5.3`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a performance issue where the initialization of SDK extensions could block the main thread for a while.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-core-261"
    }}>{`iOS Core 2.6.1`}</h3>
    <ul>
      <li parentName="ul">{`Added an internal enum for Cordova support.`}</li>
    </ul>
    <h2 {...{
      "id": "april-17-2020"
    }}>{`April 17, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-mobile-services-106"
    }}>{`iOS Mobile Services 1.0.6`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where the modal fullscreen message was shown with a white space at the top of the image.`}</li>
    </ul>
    <h2 {...{
      "id": "april-9-2020"
    }}>{`April 9, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-core-152"
    }}>{`Android Core 1.5.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed several security issues.`}</li>
      <li parentName="ul">{`Improved existing log messages and added additional logging to assist with debugging.`}</li>
    </ul>
    <h3 {...{
      "id": "android-lifecycle-103"
    }}>{`Android Lifecycle 1.0.3`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where the `}<inlineCode parentName="li">{`Resolution`}</inlineCode>{` was captured in non-English numerals.`}</li>
    </ul>
    <h2 {...{
      "id": "april-2-2020"
    }}>{`April 2, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-core-260"
    }}>{`iOS Core 2.6.0`}</h3>
    <ul>
      <li parentName="ul">{`Added support for overriding internal network stack with customer-provided implementation. For more information, see `}<a parentName="li" {...{
          "href": "../mobile-core/platform-services/index.md#ios"
        }}>{`Override network stack`}</a>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "april-7-2020"
    }}>{`April 7, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-project-griffon-114"
    }}>{`Android Project Griffon 1.1.4`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where Griffon pinpad screen may disappear behind an activity.`}</li>
      <li parentName="ul">{`Griffon SDK attempts to seamlessly reconnect to its session on network interruption.`}</li>
      <li parentName="ul">{`Fixed a bug that prevented to establish Griffon connection on Android API 27 and below.`}</li>
      <li parentName="ul">{`Added a new Plugin interface method that gets called on Griffon session termination.`}</li>
    </ul>
    <h2 {...{
      "id": "march-30-2020"
    }}>{`March 30, 2020`}</h2>
    <h3 {...{
      "id": "android-userprofile-110"
    }}>{`Android UserProfile 1.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Added an API `}<inlineCode parentName="li">{`removeUserAttributes`}</inlineCode>{` to remove multiple attributes.`}</li>
      <li parentName="ul">{`Added an API `}<inlineCode parentName="li">{`getUserAttributes`}</inlineCode>{` to get user attributes with provided keys.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-userprofile-210"
    }}>{`iOS UserProfile 2.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Added an API `}<inlineCode parentName="li">{`removeUserAttributes`}</inlineCode>{` to remove multiple attributes.`}</li>
      <li parentName="ul">{`Added an API `}<inlineCode parentName="li">{`getUserAttributes`}</inlineCode>{` to get user attributes with provided keys.`}</li>
    </ul>
    <h2 {...{
      "id": "march-19-2020"
    }}>{`March 19, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-campaign-classic-101"
    }}>{`Android Campaign Classic 1.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Report extension details to Mobile Core for improved logging and Griffon support.`}</li>
      <li parentName="ul">{`Fixed a security issue where hex conversion method was vulnerable to hash collisions.`}</li>
    </ul>
    <h2 {...{
      "id": "march-11-2020"
    }}>{`March 11, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-target-115"
    }}>{`Android Target 1.1.5`}</h3>
    <ul>
      <li parentName="ul">{`Report extension details to Mobile Core for improved logging and Griffon support.`}</li>
      <li parentName="ul">{`Target Session Id will now be added as a context data parameter `}<inlineCode parentName="li">{`a.target.sessionId`}</inlineCode>{` in the internal Analytics for Target hit sent to Adobe Analytics.`}</li>
      <li parentName="ul">{`Fixed an issue, where on app close and relaunch, previously persisted tntId was not being sent in Target requests.`}</li>
    </ul>
    <h2 {...{
      "id": "march-18-2020"
    }}>{`March 18, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-project-griffon-113"
    }}>{`Android Project Griffon 1.1.3`}</h3>
    <ul>
      <li parentName="ul">{`Added support for capturing device screenshot.`}</li>
      <li parentName="ul">{`Added support for forwarding application logs to Griffon.`}</li>
      <li parentName="ul">{`Added support for editing loaded launch configuration through Griffon.`}</li>
      <li parentName="ul">{`Added support for dispatching fake events from Griffon.`}</li>
      <li parentName="ul">{`Unique clientID and sessionID are now shared through Griffon shared state.`}</li>
      <li parentName="ul">{`Shared state contents of all the registered extensions are now forwarded to Griffon.`}</li>
      <li parentName="ul">{`Added constructors to create GriffonEvent with vendor, type, payload, and timestamp.`}</li>
      <li parentName="ul">{`Bug fixes.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-campaign-classic-203"
    }}>{`iOS Campaign Classic 2.0.3`}</h3>
    <ul>
      <li parentName="ul">{`Report extension details to Mobile Core for improved logging and Griffon support.`}</li>
      <li parentName="ul">{`Fixed an issue where passing nil callback in `}<inlineCode parentName="li">{`registerDevice`}</inlineCode>{` API caused a crash.`}</li>
    </ul>
    <h2 {...{
      "id": "march-16-2020"
    }}>{`March 16, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-core-251"
    }}>{`iOS Core 2.5.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a crash which happened in `}<inlineCode parentName="li">{`ADBJsonType::Get`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Fixed a crash which happened in `}<inlineCode parentName="li">{`EventHubInner::CreateOrUpdateSharedStateCommon`}</inlineCode>{`, the crash was introduced on the version 2.5.0.`}</li>
      <li parentName="ul">{`Fixed an internal issue where the SDK failed to create a Json array if it contains empty items.`}</li>
      <li parentName="ul">{`Improved log messages.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-identity-221"
    }}>{`iOS Identity 2.2.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue where all Identity APIs with callbacks were subject to a timeout. Only Identity APIs which use a completionHandler callback are subject to a timeout.`}</li>
      <li parentName="ul">{`Improved existing log messages and added additional logging to assist with debugging.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-signal-204"
    }}>{`iOS Signal 2.0.4`}</h3>
    <ul>
      <li parentName="ul">{`Report extension details to Mobile Core for improved logging and Griffon support.`}</li>
      <li parentName="ul">{`Improved log messages.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-lifecycle-204"
    }}>{`iOS Lifecycle 2.0.4`}</h3>
    <ul>
      <li parentName="ul">{`Report extension details to Mobile Core for improved logging and Griffon support.`}</li>
      <li parentName="ul">{`Improved log messages.`}</li>
    </ul>
    <h2 {...{
      "id": "march-10-2020"
    }}>{`March 10, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-target-216"
    }}>{`iOS Target 2.1.6`}</h3>
    <ul>
      <li parentName="ul">{`Report extension details to Mobile Core for improved logging and Griffon support.`}</li>
      <li parentName="ul">{`Target Session Id will now be added as a context data parameter `}<inlineCode parentName="li">{`a.target.sessionId`}</inlineCode>{` in the internal Analytics for Target hit sent to Adobe Analytics.`}</li>
    </ul>
    <h2 {...{
      "id": "march-2-2020"
    }}>{`March 2, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-analytics-223"
    }}>{`iOS Analytics 2.2.3`}</h3>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`AnalyticsResponse`}</inlineCode>{` events are now always dispatched regardless if the debugApi is enabled or if AAM forwarding is enabled.`}</li>
      <li parentName="ul">{`Report extension details to ACPCore for improved logging and Griffon support.`}</li>
      <li parentName="ul">{`Improved existing log messages and added additional logging to assist with debugging.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-project-griffon-110"
    }}>{`iOS Project Griffon 1.1.0`}</h3>
    <ul>
      <li parentName="ul">{`Added support for capturing device screenshot.`}</li>
      <li parentName="ul">{`Added support for forwarding application logs to Griffon.`}</li>
      <li parentName="ul">{`Added support for editing loaded launch configuration through Griffon.`}</li>
      <li parentName="ul">{`Added support for dispatching fake events from Griffon.`}</li>
      <li parentName="ul">{`Unique clientID and sessionID are now shared through Griffon shared state.`}</li>
      <li parentName="ul">{`Shared state contents of all the registered extensions are now forwarded to Griffon`}</li>
      <li parentName="ul">{`Griffon event now includes eventNumber and timestamp.`}</li>
      <li parentName="ul">{`Added an API to create ACPGriffonEvent with vendor, type, payload, and timestamp.`}</li>
      <li parentName="ul">{`Bug fixes.`}</li>
    </ul>
    <h2 {...{
      "id": "february-27-2020"
    }}>{`February 27, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-core-151"
    }}>{`Android Core 1.5.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug where AppID used non-arabic numbers as app versions.`}</li>
      <li parentName="ul">{`Fixed a bug where app version was not included in AppID on Android 9 or above devices.`}</li>
      <li parentName="ul">{`Added Wrapper Type for Flutter.`}</li>
    </ul>
    <h3 {...{
      "id": "android-signal-103"
    }}>{`Android Signal 1.0.3`}</h3>
    <ul>
      <li parentName="ul">{`Logging improvement`}</li>
      <li parentName="ul">{`Report extension details to Mobile Core for improved logging and Griffon support.`}</li>
    </ul>
    <h3 {...{
      "id": "android-lifecycle-103-1"
    }}>{`Android Lifecycle 1.0.3`}</h3>
    <ul>
      <li parentName="ul">{`Logging improvement`}</li>
      <li parentName="ul">{`Report extension details to Mobile Core for improved logging and Griffon support.`}</li>
    </ul>
    <h2 {...{
      "id": "february-19-2020"
    }}>{`February 19, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-core-250"
    }}>{`iOS Core 2.5.0`}</h3>
    <ul>
      <li parentName="ul">{`Mobile Core now shares the list of enabled extensions and their meta data through shared state.`}</li>
      <li parentName="ul">{`Added Wrapper Type for Flutter.`}</li>
      <li parentName="ul">{`Exposed eventNumber and eventTimestamp in ACPExtensionEvent class.`}</li>
      <li parentName="ul">{`Added the following API to support the completion handler with an nullable `}<inlineCode parentName="li">{`NSError`}</inlineCode>{` object:`}
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`getPrivacyStatusWithCompletionHandler`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`getSdkIdentitiesWithCompletionHandler`}</inlineCode></li>
        </ul>
      </li>
    </ul>
    <h3 {...{
      "id": "ios-identity-220"
    }}>{`iOS Identity 2.2.0`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Report extension details to Mobile Core for improved logging and Griffon support.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Added the following APIs to support the completionHandler callback that is available in iOS ACPCore version 2.5.0:`}</p>
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`appendToURL:withCompletionHandler`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`getUrlVariablesWithCompletionHandler`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`getIdentifiersWithCompletionHandler`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`getExperienceCloudIdWithCompletionHandler`}</inlineCode></li>
        </ul>
        <p parentName="li">{`When the `}<inlineCode parentName="p">{`completionHandler`}</inlineCode>{` is used, and you are retrieving the Mobile SDK values, the timeout value is 500ms; if the operation times out or is not successful, an `}<inlineCode parentName="p">{`NSError`}</inlineCode>{` is returned.`}</p>
      </li>
    </ul>
    <h2 {...{
      "id": "february-13-2020"
    }}>{`February 13, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-analytics-124"
    }}>{`Android Analytics 1.2.4`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue which, was causing some hits to be delayed.`}</li>
      <li parentName="ul">{`Fixed an issue where `}<inlineCode parentName="li">{`AnalyticsResponse`}</inlineCode>{` events were not being dispatched even when the debug API was enabled.`}</li>
      <li parentName="ul">{`Report extension details to Mobile Core for improved logging and Griffon support.`}</li>
      <li parentName="ul">{`Improved existing log messages and added additional logging to assist with debugging.`}</li>
    </ul>
    <h2 {...{
      "id": "february-4-2020"
    }}>{`February 4, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-core-150"
    }}>{`Android Core 1.5.0`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Fixed a cursor leak.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Mobile Core now shares the list of enabled extensions and their meta data through shared state.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Fixed an issue where the advertising identifier was duplicated in the response to the `}<inlineCode parentName="p">{`MobileCore.getSDKIdentifiers`}</inlineCode>{` API.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Added support for overriding internal network stack with customer-provided code.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Added a new interface with failure callback, `}<inlineCode parentName="p">{`AdobeCallbackWithError`}</inlineCode>{`, which can be used with the `}<inlineCode parentName="p">{`MobileCore.getPrivacyStatus`}</inlineCode>{` and `}<inlineCode parentName="p">{`MobileCore.getSdkIdentities`}</inlineCode>{` methods.`}</p>
        <p parentName="li">{`We plan to gradually add the ability to enable failure callback to the other extensions.`}</p>
      </li>
    </ul>
    <h3 {...{
      "id": "android-identity-120"
    }}>{`Android Identity 1.2.0`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Added support for the optional `}<inlineCode parentName="p">{`AdobeCallbackWithError`}</inlineCode>{` callback that is available in Android Core version 1.5.0 on the following APIs:`}</p>
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`appendVisitorInfoForURL`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`getUrlVariables`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`getIdentifiers`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`getExperienceCloudId`}</inlineCode></li>
        </ul>
        <p parentName="li">{`When the `}<inlineCode parentName="p">{`AdobeCallbackWithError`}</inlineCode>{` is used, and you are retrieving the Mobile SDK values, the timeout value is 500ms; if the operation times out or is not successful, an `}<inlineCode parentName="p">{`AdobeError`}</inlineCode>{` is returned.`}</p>
      </li>
    </ul>
    <p>{`Released with sdk-core version 1.5.0.`}</p>
    <h3 {...{
      "id": "android-mobile-services-111"
    }}>{`Android Mobile Services 1.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Improved existing log messages and added additional logging to assist with debugging.`}</li>
    </ul>
    <h2 {...{
      "id": "january-28-2019"
    }}>{`January 28, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <p><strong parentName="p">{`iOS Project Griffon 1.0.4`}</strong></p>
    <ul>
      <li parentName="ul">{`Griffon SDK adds and reports uniqueIdentifier and timestamp associated with eventHub events. (works from Core v2.4.0).`}</li>
      <li parentName="ul">{`Improved Logging to assist with debugging.`}</li>
    </ul>
    <h3 {...{
      "id": "android-mobile-services-111-1"
    }}>{`Android Mobile Services 1.1.1`}</h3>
    <ul>
      <li parentName="ul">{`Improved existing log messages and added additional logging to assist with debugging.`}</li>
    </ul>
    <h2 {...{
      "id": "january-29-2020"
    }}>{`January 29, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-target-114"
    }}>{`Android Target 1.1.4`}</h3>
    <ul>
      <li parentName="ul">{`Improved existing log messages and added additional logging to assist with debugging.`}</li>
    </ul>
    <h3 {...{
      "id": "android-campaign-103"
    }}>{`Android Campaign 1.0.3`}</h3>
    <ul>
      <li parentName="ul">{`Improved existing log messages and added additional logging to assist with debugging.`}</li>
    </ul>
    <h2 {...{
      "id": "january-28-2019-1"
    }}>{`January 28, 2019`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-project-griffon-112"
    }}>{`Android Project Griffon 1.1.2`}</h3>
    <ul>
      <li parentName="ul">{`Fixed the nomenclature for the unique event identifier.`}</li>
    </ul>
    <h2 {...{
      "id": "january-27-2020"
    }}>{`January 27, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "ios-core-240"
    }}>{`iOS Core 2.4.0`}</h3>
    <ul>
      <li parentName="ul">{`Added a new property, `}<inlineCode parentName="li">{`eventUniqueIdentifier`}</inlineCode>{`, to the `}<inlineCode parentName="li">{`ACPExtensionEvent`}</inlineCode>{` class.`}</li>
      <li parentName="ul">{`Fixed an issue where the advertising identifier was duplicated in the response to the `}<inlineCode parentName="li">{`getSDKIdentifiers`}</inlineCode>{` API.`}</li>
      <li parentName="ul">{`Fixed an issue where the SDK was trying to download the rules multiple times immediately after app launch.`}</li>
      <li parentName="ul">{`Fixed a crash on `}<inlineCode parentName="li">{`std::__1::system_error: mutex lock failed: Invalid argument`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Fixed a bug where the iOS fullscreen message was unable to load cached images.`}</li>
    </ul>
    <h2 {...{
      "id": "january-25-2020"
    }}>{`January 25, 2020`}</h2>
    <h3 {...{
      "id": "android-analytics-123"
    }}>{`Android Analytics 1.2.3`}</h3>
    <ul>
      <li parentName="ul">{`requestEventIdentifier is now appended to all non-track events so that Lifecycle (or other extension events that are sent to Analytics) can be viewed with rich detail in Project Griffon.`}</li>
    </ul>
    <h3 {...{
      "id": "ios-analytics-222"
    }}>{`iOS Analytics 2.2.2`}</h3>
    <ul>
      <li parentName="ul">{`requestEventIdentifier is now appended to all non-track events so that Lifecycle (or other extension events that are sent to Analytics) can be viewed with rich detail in Project Griffon.`}</li>
    </ul>
    <h2 {...{
      "id": "january-24-2020"
    }}>{`January 24, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-project-griffon-111"
    }}>{`Android Project Griffon 1.1.1`}</h3>
    <ul>
      <li parentName="ul">{`The Griffon SDK now reports an event's source, type, sequence number and timestamp for every event.`}</li>
      <li parentName="ul">{`The Griffon SDK adds and reports `}<inlineCode parentName="li">{`uniqueIdentifier`}</inlineCode>{` associated with eventHub events. This update is effective from Mobile Core version 1.4.2`}</li>
      <li parentName="ul">{`Removed unwanted resource files that were creating compilation error.`}</li>
      <li parentName="ul">{`Improved logging to assist with debugging.`}</li>
    </ul>
    <h2 {...{
      "id": "january-23-2020"
    }}>{`January 23, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-mobile-services-110"
    }}>{`Android Mobile Services 1.1.0`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`The shared state of the Profile extension can now be used as the traits for In-App Messaging.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Added a new API, `}<inlineCode parentName="p">{`MobileServices.processGooglePlayInstallReferrerUrl(final String url)`}</inlineCode>{`, to support Google Play Install Referrer APIs.`}</p>
        <p parentName="li">{`For more information about the Install Referrer APIs, see `}<a parentName="p" {...{
            "href": "https://android-developers.googleblog.com/2019/11/still-using-installbroadcast-switch-to.html"
          }}>{`Still Using InstallBroadcast? Switch to the Play Referrer API by March 1, 2020`}</a>{`.`}</p>
      </li>
    </ul>
    <h3 {...{
      "id": "ios-mobile-services-105"
    }}>{`iOS Mobile Services 1.0.5`}</h3>
    <ul>
      <li parentName="ul">{`The shared state of the Profile extension can now be used as the traits for In-App Messaging.`}</li>
    </ul>
    <h2 {...{
      "id": "january-13-2020"
    }}>{`January 13, 2020`}</h2>
    <p>{`The following updates were made in this release:`}</p>
    <h3 {...{
      "id": "android-project-griffon-110"
    }}>{`Android Project Griffon 1.1.0`}</h3>
    <ul>
      <li parentName="ul">{`The Griffon bridge and the Griffon SDK are now unified.`}</li>
      <li parentName="ul">{`The Adobe Analytics debug flag is now enabled when you start a Griffon session and is disabled when you end the session.`}</li>
      <li parentName="ul">{`The client-side Griffon UI now logs Location Service entry and exit events.`}</li>
      <li parentName="ul">{`Modified the client UI to include client-side logging capabilities.`}</li>
      <li parentName="ul">{`Fixed an issue for Android API version 28 or later where multiple WebViews cannot share the same data directory.`}</li>
      <li parentName="ul">{`Added generic exception handling for exceptions that can occur when WebViews are accessed while OS is updating Chrome.`}</li>
    </ul>
    <p>{`The Project Griffon web UI now has new views specifically for users who are trying to inspect and improve Adobe Analytics and Location Service (Places) implementations.`}</p>
    <h3 {...{
      "id": "ios-project-griffon-103"
    }}>{`iOS Project Griffon 1.0.3`}</h3>
    <ul>
      <li parentName="ul">{`The Griffon bridge and the Griffon SDK are now unified.`}</li>
      <li parentName="ul">{`The Adobe Analytics debug flag is now enabled when you start a Griffon session and is disabled when you end the session.`}</li>
      <li parentName="ul">{`The client-side Griffon UI now logs Location Service entry and exit events.`}</li>
      <li parentName="ul">{`This version is compatible with iOS 13.`}</li>
      <li parentName="ul">{`Fixed a crash in LIBDISPATCH.`}</li>
    </ul>
    <p>{`The Project Griffon web UI now has new views specifically for users who are trying to inspect and improve Adobe Analytics and Location Service (Places) implementations.`}</p>
    <h3 {...{
      "id": "adobe-analytics-view"
    }}>{`Adobe Analytics View`}</h3>
    <p>{`The new Adobe Analytics view shows you events that are only related to your Adobe Analytics implementation. The list view now displays the action/state name and event, `}<inlineCode parentName="p">{`status`}</inlineCode>{`, with a newly formatted detail view. `}<inlineCode parentName="p">{`status`}</inlineCode>{` tells you when an SDK event is generated (processed), whether the SDK has made a network request with Adobe Analytics (queued), and whether post-processing information about the event (validated) is returned. This information helps you determine whether your context data is being appropriately mapped in Adobe Analytics.`}</p>
    <p>{`The detailed view for an Analytics track event contains the following parts:`}</p>
    <ul>
      <li parentName="ul">{`The originating SDK Analytics request event.`}</li>
      <li parentName="ul">{`The OOTB meta and context data from the request, such as the report suite ID, the SDK extension versions, the OOTB context data, and so on.`}</li>
      <li parentName="ul">{`The post-processed information on the Analytics event, which contains mapping of revars, evars, props, and so on.`}</li>
    </ul>
    <h3 {...{
      "id": "location-service-places-view"
    }}>{`Location Service (Places) View`}</h3>
    <p>{`The new Location Services views allow you to inspect location entry and exit events on the Project Griffon web UI and on a mobile device. Depending on your business workflows, these views provide a convenient interface to view location-specific data points for inspection on the web/client for in-context debugging.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      